import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from './../../../../../../core/toast.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { AddSupplySubCategoryService } from '../../services/add-supply-sub-category.service';
@Component({
  selector: 'app-add-supply-sub-category',
  templateUrl: './add-supply-sub-category.component.html',
  styleUrls: ['./add-supply-sub-category.component.scss']
})
export class AddSupplySubCategoryComponent implements OnInit {

  supplyCategoryForm = this.fb.group({
    supply_category_id: [null, [Validators.required]],
    name: [null, [Validators.required]]
  })

  constructor(
    private fb: FormBuilder,
    private addSupplySubCategoryService: AddSupplySubCategoryService,
    private toast: ToastService,
    private matDialogRef: MatDialogRef<AddSupplySubCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if(this.data){
      this.supply_category_id.setValue(this.data.supply_category_id);
      this.name.setValue(this.data.name);
    }
  }


  async addSupplySubCategory(){
    if(this.supplyCategoryForm.invalid){
      this.toast.openSnackBar('Please enter valid name');
      this.supplyCategoryForm.markAllAsTouched();
      return;
    }
    const supplyCategory = this.supplyCategoryForm.value as any;
    try {
      const response = await this.addSupplySubCategoryService.addSupplySubCategory(supplyCategory);
      this.toast.openSnackBar('Sub category added successfully');
      this.closeDialog(response);
    } catch(error){
      this.toast.openSnackBar('Unable to add Sub category');
    }

  }

  closeDialog(status: any){
        document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.matDialogRef.close(status); }, 1000);
  }

  /* --------------------------------- Getters -------------------------------- */

  get name(){
    return this.supplyCategoryForm.get('name')
  }
  get supply_category_id(){
    return this.supplyCategoryForm.get('supply_category_id')
  }
}

